import React from "react";
import { AlertTriangle, ChevronRight } from "lucide-react";
import { formatDueLabel, isOverdueDueLabel } from "../utils/taskDates";

const TaskAssignmentView = ({ groups, onSelectTask, onSelectGroup }) => (
    <div className="space-y-3">
        {groups.length === 0 && (
            <div className="rounded-lg border border-dashed border-line p-6 text-center text-ink-muted text-sm">
                No assigned tasks yet.
            </div>
        )}
        {groups.map((group) => (
            <div
                key={group.assignTo}
                className="rounded-xl border border-line bg-surface-2 overflow-hidden"
            >
                <button
                    type="button"
                    onClick={() => onSelectGroup?.(group.assignTo)}
                    className="w-full flex items-center justify-between gap-3 p-3 hover:bg-surface-3 transition text-left"
                >
                    <div className="min-w-0">
                        <p className="font-semibold text-ink text-sm truncate">
                            {group.name}
                        </p>
                        <div className="flex flex-wrap gap-2 mt-1">
                            <span className="text-xs text-ink-muted">
                                {group.active} active
                            </span>
                            {group.overdue > 0 && (
                                <span className="text-xs font-medium text-error flex items-center gap-0.5">
                                    <AlertTriangle size={12} />
                                    {group.overdue} overdue
                                </span>
                            )}
                            {group.high > 0 && (
                                <span className="text-xs font-medium text-warning">
                                    {group.high} high priority
                                </span>
                            )}
                        </div>
                    </div>
                    <ChevronRight size={16} className="text-ink-muted shrink-0" />
                </button>
                <div className="border-t border-line divide-y divide-line">
                    {group.tasks
                        .filter((t) => t.status !== "Completed")
                        .slice(0, 5)
                        .map((task) => (
                            <button
                                key={task.id}
                                type="button"
                                onClick={() => onSelectTask(task)}
                                className="w-full flex items-center justify-between gap-2 px-3 py-2.5 hover:bg-surface-3 transition text-left min-h-[44px]"
                            >
                                <span className="text-sm text-ink truncate flex-1">
                                    {task.title}
                                </span>
                                <span
                                    className={`text-[11px] font-medium shrink-0 ${
                                        isOverdueDueLabel(formatDueLabel(task))
                                            ? "text-error"
                                            : "text-ink-muted"
                                    }`}
                                >
                                    {formatDueLabel(task) || task.priority}
                                </span>
                            </button>
                        ))}
                    {group.active > 5 && (
                        <p className="px-3 py-2 text-xs text-ink-muted">
                            +{group.active - 5} more active tasks
                        </p>
                    )}
                </div>
            </div>
        ))}
    </div>
);

export default TaskAssignmentView;
